export default __webpack_public_path__ + "static/media/amanita1.96e322bd.png";